import { useEffect, useMemo, useState, useRef } from "react";
import Table from "../../components/GTable/Table";
import { GetCategoriesData, GetOrderByIdData, GetOrdersData, GetOrdersExportData, GetStoresData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { ordersColumns, stateOfDeliveryBoy, stateOfOrders, stateOfStores } from "../../lib/definitions";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { MdOutlineFileUpload } from "react-icons/md";
import OrdersFilter from "../../ui/searchFilter/ordersFilter";
import OrderDetailsPop from "../../ui/orders/orderDetailsPop";
import { getOrderByUserId } from "../../lib/apiCalls";
import NotData from "../../ui/sharedUi/noData";
import i18n from "../../lib/i18n";

export default function Orders() {

    const [searchParams] = useSearchParams();
    const [ordersData, setOrdersData] = useState([]);
    const [storeData, setStoreData] = useState([]);
    const [orderDetails, setOrderDetails] = useState({});
    const [ordersExportData, setOrdersExportData] = useState([]);
    const [categoriesParentDataFilter, setCategoriesParentDataFilter] = useState([]);
    const [categoriesChildDataFilter, setCategoriesChildDataFilter] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [last_page, setlast_page] = useState(1);
    const [openDetails, setOpenDetails] = useState({ isOpen: false, idToOpen: null });
    const [isLoading, setIsLoading] = useState(true);  
    const [showExportDialog, setShowExportDialog] = useState(false);
    const location = useLocation(); 
    const pollIntervalRef = useRef(null);
    const category_id = searchParams.get('category_id');
    const store_id = searchParams.get('store_id');
    const sub_category_id = searchParams.get('sub_category_id');
    const id = searchParams.get('id');
    const order_status = searchParams.get('order_status');
    const min_price = searchParams.get('min_price');
    const max_price = searchParams.get('max_price');
    const from_date = searchParams.get('from_date');
    const to_date = searchParams.get('to_date');
    const store_status = searchParams.get('store_status');
    const delivery_status = searchParams.get('delivery_status');
    const {userId} = useParams();
    const t = i18n.t.bind(i18n); 
    

    const params = useMemo(() => {
        const tempParams = [];
        if (category_id) tempParams.push({ category_id });
        if (store_id) tempParams.push({ store_id });
        if (sub_category_id) tempParams.push({ sub_category_id });
        if (id) tempParams.push({ id });
        if (min_price) tempParams.push({ min_price });
        if (max_price) tempParams.push({ max_price });
        if (from_date) tempParams.push({ from_date });
        if (delivery_status) tempParams.push({ delivery_status });
        if (store_status) tempParams.push({ store_status });
        if (to_date) tempParams.push({ to_date });
        if (order_status) tempParams.push({ order_status });

        return tempParams;
    }, [ sub_category_id, category_id, store_id, id, min_price, max_price, from_date, to_date, order_status, store_status, delivery_status]);


    useEffect(() => {
        handleApi();
    }, [currentPage, params ])

    useEffect(() => {
        handleFilterCategoryParent();
        handleFilterCategoryChlid();
    }, [])

    useEffect(() => {
        if (pollIntervalRef.current === null) {
            pollIntervalRef.current = setInterval(() => {
            if (openDetails.idToOpen != null) {
                fetchAndStore(openDetails.idToOpen);
            }
            }, 40000);
        }
        return () => {
            if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
            }
        };
    }, [openDetails.idToOpen]);

    const handleApi = async () => {
        setIsLoading(true); 
        const storesData = await GetStoresData();
        setStoreData([]);
        storesData.data.map((e) => setStoreData((prev) => [...prev, e]));

        let ordersData = [];
        if(location.pathname.startsWith("/users/details/")){
            ordersData = await getOrderByUserId(userId, currentPage, params);
            setOrdersData([]);
            ordersData.data.data.map((e) => setOrdersData((prev) => [...prev, e]));
            setcurrentPage(ordersData.data.pagination.current_page);
            setlast_page(ordersData.data.pagination.last_page);
        }
        else{
            ordersData = await GetOrdersData(currentPage, params);
            setOrdersData([]);
            ordersData.data.map((e) => setOrdersData((prev) => [...prev, e]));
            setcurrentPage(ordersData.pagination.current_page);
            setlast_page(ordersData.pagination.last_page);
        }
        setIsLoading(false);  
    };

    const handleFilterCategoryParent = async () => {
        const params = [ {"status" : "main"} ];
        const categoriesDataFilter = await GetCategoriesData(1, params);
        setCategoriesParentDataFilter([]);
        categoriesDataFilter.data.map((e) => setCategoriesParentDataFilter((prev) => [...prev, e]));
    };

    const handleFilterCategoryChlid = async () => {
        const params = [ {"status" : "sub"} ];
        const categoriesDataFilter = await GetCategoriesData(1, params);
        setCategoriesChildDataFilter([]);
        categoriesDataFilter.data.map((e) => setCategoriesChildDataFilter((prev) => [...prev, e]));
    };

    const searchCategoryParent = async (param) => {
        const params = [ {"name": param},{"status" : "main"} ];
        if(param){
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesParentDataFilter([]);
            categoriesDataFilter.data.map((e) => setCategoriesParentDataFilter((prev) => [...prev, e]));
        }
    };

    const searchCategoryChild = async (param) => {
        const params = [ {"name": param},{"status" : "sub"} ];
        if(param){
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesChildDataFilter([]);
            categoriesDataFilter.data.map((e) => setCategoriesChildDataFilter((prev) => [...prev, e]));
        }
    };

    const searchStoresData = async (param) => {
        const params = [{"name": param}];
        if(param){
            const storeData = await GetStoresData(1,params);
            setStoreData([]);
            storeData.data.map((e) => setStoreData((prev) => [...prev, e]));
        }
    };

    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    const fetchAndStore = async (id) => {
        const orderDetails = await GetOrderByIdData(id);
        setOrderDetails(orderDetails.data);
    };

    const openOrderDetails = async (id) => {
        setOpenDetails({ isOpen: true, idToOpen: id });
        await fetchAndStore(id);
    };

    const openCloseExportDialog = (e) => {
        setShowExportDialog(e);
    };

    const ExportTableWithPaginiation = async (e) => {
        const orderExportData = await GetOrdersExportData(e, params);
        setOrdersExportData([]);
        orderExportData.data.map((e) => setOrdersExportData((prev) => [...prev, e]));
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
           
            <div className="">
                <OrdersFilter stateOfStores={stateOfStores} stateOfDeliveryBoy={stateOfDeliveryBoy} searchStoresData={searchStoresData} storesData={storeData} searchCategoryParent={searchCategoryParent} searchCategoryChild={searchCategoryChild} categoriesChildData={categoriesChildDataFilter} categoriesParentData={categoriesParentDataFilter} stateOfOrders={stateOfOrders} values={params} />
            </div>
            <div className="flex flex-col sm:flex-row sm:items-baseline border-t border-gray-500/100 bg-thirdly  justify-between px-5 py-5  gap-4">
                <div></div>
                <div onClick={()=>openCloseExportDialog(true)}>
                    <Button background="#302c4a" borderRadius="8px" border="border border-gray-500/80" color="white" padding="8px 24px" text={t("button.export")} icon={<MdOutlineFileUpload />} />
                </div>
            </div>
        
            { (ordersData.length > 0 || isLoading) &&
                <div>
                    {isLoading ? <TableSkeleton cols={ordersColumns}/> : (  
                        <Table name={"Orders"} showExportDialog={showExportDialog} openCloseExportDialog={openCloseExportDialog} ExportTableWithPaginiation={ExportTableWithPaginiation} rowsExportPaginiation={ordersExportData} columns={ordersColumns} rows={ordersData} action="confirm" openOrderDetails={openOrderDetails} />
                    )}
                </div>
            }
            { (ordersData.length < 1 && !isLoading) &&
                <div>
                    <NotData />
                </div>
            }
            <div className="flex justify-center items-center py-5">
                <Pagination currentPage={currentPage} totalPages={last_page} handleChangePage={handlePageChange} />
            </div>
            {openDetails.isOpen && openDetails.idToOpen && <OrderDetailsPop data={orderDetails} onClose={() => setOpenDetails({ idToOpen : null, isOpen : false })} />}
        </div>
    );
};